import { render, staticRenderFns } from "./Friend-links.vue?vue&type=template&id=ada8ce8e&scoped=true"
import script from "./Friend-links.vue?vue&type=script&lang=js"
export * from "./Friend-links.vue?vue&type=script&lang=js"
import style0 from "./Friend-links.vue?vue&type=style&index=0&id=ada8ce8e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada8ce8e",
  null
  
)

export default component.exports